export const NewsletterArchivePage = () => {

  const $newsletterArchive = $('.newsletter-archive')
  const $covers = $newsletterArchive.find('.wp-block-cover:has(a)')

  if ($newsletterArchive.length && $covers.length) {
    initPage()
  }

  function initPage() {
    $covers.each(function () {
      const $cover = $(this)
      const $link = $cover.find('a')
      $cover.on('click' , (event) => {
        if (!event.ctrlKey && !event.metaKey && event.button === 0) {
          event.preventDefault();
          window.location.href = $link.attr('href');
        }
      })
    })
  }

}